import { useEffect, useState } from "react";
import api from "@/lib/api";

// Sauvegarde automatique universelle d'un champ texte, isolée par compte.
// Restaure au montage puis enregistre (débounce) à chaque changement.
export function useAutosave(key, value, setValue, { enabled = true, title = "", kind = "draft" } = {}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) { setReady(true); return; }
    let alive = true;
    api.get(`/drafts/${encodeURIComponent(key)}`)
      .then(({ data }) => {
        const c = data?.draft?.content;
        if (alive && c && !value) setValue(c);
      })
      .catch(() => {})
      .finally(() => { if (alive) setReady(true); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled]);

  useEffect(() => {
    if (!enabled || !ready) return;
    const id = setTimeout(() => {
      api.put(`/drafts/${encodeURIComponent(key)}`, { key, content: value || "", title, kind }).catch(() => {});
    }, 900);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, ready, enabled, key]);
}

export async function clearDraft(key) {
  try { await api.delete(`/drafts/${encodeURIComponent(key)}`); } catch (_) { /* noop */ }
}
